import React from 'react';

type Props = {
  content: string,
  customStyle?: Object,
};

function RowHeader(props: Props) {
  const { content, customStyle } = props;
  return (
    <div className="row-header u--marginNone-top">
      <div className="row-header__title">
        <span className="row-header__text" style={customStyle || null}>
          {content}
        </span>
      </div>
    </div>
  );
}

RowHeader.defaultProps = {
  customStyle: null,
};

export default RowHeader;
